import { Link } from 'gatsby';
import { GatsbyImage, getImage as getGatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from '../../../constants/colors';
import ArrowRight from '../../Global/ArrowRight';
import { getRecircLink, getRecircTitle } from './Mappings';

const StaticCard = ({ data, type = 'standard' }) => {
  const { body, color, image, mediaType, recircLink, staticHeader } = data;
  let getHeader = staticHeader;
  if (image === null) {
    getHeader = staticHeader.substring(0, 5);
  }
  let headerType = 'large';
  if (getHeader.length > 20) {
    headerType = 'small';
  } else if (getHeader.length > 5) {
    headerType = 'medium';
  }
  const isImage = image && mediaType === 'Image' && type !== 'standard';

  const text = (
    <div className="text">
      <h1 className={`header ${headerType} ${isImage ? mediaType : ''}`}>
        {getHeader}
      </h1>
      <p className="body" style={isImage ? { color } : null}>
        {body}
      </p>
      <Link
        className="link"
        style={isImage ? { color } : null}
        to={getRecircLink(recircLink)}
      >
        {`More in ${getRecircTitle(recircLink)}`}
        <ArrowRight color={isImage ? color : COLORS.liquorice} />
      </Link>
    </div>
  );

  const getImage = image ? (
    <GatsbyImage image={getGatsbyImage(image)} style={{ height: '100%' }} />
  ) : null;

  const media = (
    <div className={`media ${type} `}>
      <div className={`image ${mediaType} `}>
        {mediaType === 'Illustration' ? (
          <div className="image-box">{getImage}</div>
        ) : (
          getImage
        )}
      </div>

      {text}
    </div>
  );

  return (
    <div
      className={`static-card ${type}`}
      style={!isImage ? { background: color } : null}
    >
      {image && type !== 'standard' ? media : text}
    </div>
  );
};
StaticCard.propTypes = {
  data: PropTypes.object,
  type: PropTypes.oneOf(['standard', 'tall', 'long']),
};

export default StaticCard;
